<div
  *ngIf="visible"
  [ngClass]="[
    'esl-tag',
    removable ? 'removable' : '',
    disabled ? 'disabled' : '',
    forceSmallScreenMode ? 'smaller-font' : '',
    clickable ? 'clickable' : '',
    static ? 'static' : ''
  ]"
  [ngStyle]="{
    backgroundColor: color ? color : '',
    color: textColor ? textColor : '',
    fontWeight: 400
  }"
>
  <i *ngIf="icon" [ngClass]="[icon, 'icon']"></i>
  <span>{{ label }}</span>
  <i *ngIf="removable" class="close icon" (click)="remove()"></i>
</div>
